import styled from 'styled-components';

import {sanitizeEmailHtml} from '../../utils/sanitizeEmailHtml';

interface MessageTextProps {
  htmlData: string;
}

export function MessageText(props: MessageTextProps) {
  return (
    // eslint-disable-next-line eslint-js/no-restricted-syntax, react/no-danger -- Sanitized by backend, returned only by BE
    <MessageTextDiv dangerouslySetInnerHTML={{__html: sanitizeEmailHtml(props.htmlData)}} />
  );
}

// Important due to styled html elements
// eslint-disable-next-line eag/no-css-property
const MessageTextDiv = styled.div`
  font-size: ${({theme}) => theme.fontSizes.text.small} !important;
  color: ${({theme}) => theme.colors.text.primary} !important;
  background-color: transparent !important;
  max-width: 100%;
  overflow-x: auto;

  * {
    background-color: transparent !important;
    color: ${({theme}) => theme.colors.text.primary} !important;
  }

  /* Emails use fixed-width tables/images — cap them so the preview never outgrows the dialog */
  table {
    border-collapse: unset;
    max-width: 100% !important;

    a {
      display: flex;
      width: max-content;
      justify-content: center;
    }
  }

  img {
    max-width: 100% !important;
    height: auto !important;
  }
`;
